<template>
  <nav-bar title="系统帮助" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <van-cell v-for="item in list" :key="item.id" :title="item.title" is-link :url="item.url"  />
  </Content>
</template>

<script>
import { getHelpList } from '@/api/user'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
export default {
  name: 'Help',
  setup () {
    const store = useStore()
    const roleId = computed(() => store.state.roleInfo.roleId)
    const list = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getHelpList, (data) => {
      list.value = data
    }, roleId.value)
    getDataLoading()
    return { getDataLoading, showLoading, isLoading, list }
  }
}
</script>

<style lang="scss" scoped>

</style>
